import { Component, DoCheck, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input } from "@angular/core";
import { state, style, animate, transition, trigger, AnimationEvent } from "@angular/animations";

import { ServiceModelManagerServices } from "../../services/service-model-manager.services";
import { MongoImageServices } from "../../services/mongoImage.services";
import { MongoVideoServices } from "../../services/mongoVideo.services";
import { MongoImageModel } from "../../models/mongoImage.model";
import { MongoVideoModel } from "../../models/mongoVideo.model";
import { AppModalServices } from "../../services/app-modal.services";
import { MongoCursorModel } from "../../models/mongoCursor.model";

const autoComplete = require( '../../../js/autoComplete.js' );

const $ = require( 'jquery' );

@Component( {
  selector: 'app-search-field',
  template: require( './search-field.component.pug' ),
  styles: [ require('./search-field.component.scss') ],
  animations: [
    trigger( 'search', [
      state('*', style( {
        width: '25px',
        background: 'transparent'
      } ) ),
      state('openSearch', style( {
        width: '200px',
        position: 'absolute',
        transform: 'translate(75px,75px)',
        opacity: 0.75,
        background: 'white',
        color: 'black',
        zIndex: 1000,
      } ) ),
      transition( '* => openSearch', [
        animate( '200ms' )
      ] ),
      transition( 'openSearch => *', [
        animate( '100ms' )
      ] )
    ] ),
  ]
} )

export class SearchFieldComponent implements OnInit, OnDestroy {
  private searchState: string;
  private searchIsDone: boolean = true;
  private searchTermsImages: any;
  private searchTermsVideos: any;
  private autoCompleteElement : HTMLInputElement;
  private modalSource: string;
  private activeSearchTerms: any;
  private imageTermsSubscription: any;
  private videoTermsSubscription: any;
  private serviceSubscription: any;
  private activeService: string;

  constructor(
    private service: ServiceModelManagerServices,
    private videos: MongoVideoServices,
    private images: MongoImageServices,
    private modal: AppModalServices
  ) {}

  ngOnInit(): void {

    this.serviceSubscription = this.service.serviceReady.subscribe( ( service: string ) => {
      this.activeService = service;
    })

    this.imageTermsSubscription = this.images.onUpdatedSearchTerms.subscribe( ( updatedTerms: any ) => {
      if ( updatedTerms ) {
        const { terms, isSearch } = updatedTerms;
        this.searchTermsImages = terms;
      }
    })

    this.videoTermsSubscription = this.videos.onUpdatedSearchTerms.subscribe( ( updatedTerms: any ) => {
      if ( updatedTerms ) {
        const { terms, isSearch } = updatedTerms;
        this.searchTermsVideos = terms;
      }
    })

    this.autoCompleteElement = document.querySelector( "#autoComplete" ) as HTMLInputElement;
  }

  ngOnDestroy(): void {
    this.imageTermsSubscription.unsubscribe();
    this.videoTermsSubscription.unsubscribe();
    this.serviceSubscription.unsubscribe();
  }

  @Input() view: string;

  @HostListener( 'click', [ '$event' ] ) onClickHandler( event: MouseEvent ) {
    this.searchIsDone = false;
    this.searchState = 'openSearch';
    this.autoCompleteElement.focus();
  }

  @HostListener( 'document:keyup', [ '$event' ] ) keyupEventHandler( event: KeyboardEvent ) {
    if ( event.key == 'Escape' ) {
      if ( document.querySelector( "#autoComplete_list" ) ) {
        document.querySelector( "#autoComplete_list" ).remove();
      }
      this.autoCompleteElement.value = '';
      this.searchState = null;
    }
  }



  onBegin( event: AnimationEvent ) { }

  onSelection( item: any ) {
    const selection = item.selection.value;
    const cursor = this[this.activeService].latestSearch ? this[this.activeService].latestSearch : new MongoCursorModel('search');
    const { queryTerm, title } = selection;
    const key = queryTerm.split('.')[1];

    this.autoCompleteElement.blur();

    cursor.set( {[key]: title, isSearch: true, page: 1} );
    this[this.view]['search']( cursor );

    if ( document.querySelector( "#autoComplete_list" ) ) {
      document.querySelector( "#autoComplete_list" ).remove();
    }
    this.searchState = null;
  }

  onDone( event: AnimationEvent ) {
    let inputField = event.element;
    this.activeSearchTerms = this.view === 'images' ? this.searchTermsImages : this.searchTermsVideos ;

    if ( event.toState =='openSearch' ) {

      new autoComplete( {
          data: {                              // Data src [Array, Function, Async] | (REQUIRED)
            src: async () => {
              const query = inputField.value;
              const data = this.activeSearchTerms;
              return data;
            },
            key: [ "title" ],
            cache: false
          },
          // query: {                               // Query Interceptor               | (Optional)
          //       manipulate: (query:any) => {
          //         return query.replace("pizza", "burger");
          //       }
          // },
          sort: ( a:any , b:any ) => {                    // Sort rendered results ascendingly | (Optional)
              if ( a.match < b.match ) return -1;
              if ( a.match > b.match ) return 1;
              return 0;
          },
          placeHolder: `enter ${this.view} search terms ...`,     // Place Holder text                 | (Optional)
          selector: "#autoComplete",           // Input field selector              | (Optional)
          threshold: 1,                        // Min. Chars length to start Engine | (Optional)
          debounce: 300,                       // Post duration for engine to start | (Optional)
          searchEngine: "strict",              // Search Engine type/mode           | (Optional)
          resultsList: {                       // Rendered results list object      | (Optional)
              render: true,
              container: ( source:any ) => {
                  source.setAttribute( "id", "autoComplete_list" );
              },
              destination: document.querySelector( "#autoComplete" ),
              position: "afterend",
              element: "ul"
          },
          maxResults: 5,                         // Max. number of rendered results | (Optional)
          highlight: true,                       // Highlight matching results      | (Optional)
          resultItem: {                          // Rendered result item            | (Optional)
              content: ( data:any, source:any ) => {
                  source.innerHTML = data.match;
              },
              element: "li"
          },
          noResults: () => {                     // Action script on noResults      | (Optional)
              const result = document.createElement( "li" );
              result.setAttribute( "class", "no_result" );
              result.setAttribute( "tabindex", "1" );
              result.innerHTML = "Not Found";
              document.querySelector( "#autoComplete_list" ).appendChild( result );
          },
          onSelection: ( feedback : any ) => {             // Action script onSelection event | (Optional)
              this.onSelection( feedback );
              inputField.value = feedback.selection.value.title;
          }

      })

    }
    if ( event.fromState == 'openSearch' ) {
      this.autoCompleteElement.value = '';
      this.autoCompleteElement.placeholder = '';
      this.searchIsDone = true;
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/modules/search-field/search-field.component.ts